//@flow
import * as React from 'react'
import SingleSelectAnswerQuestion from './SingleSelectAnswerQuestion'
import YesNoAnswerQuestion from './YesNoAnswerQuestion'
import type { ReviewQuestions$Props } from './flowTypes'

const SINGLE_SELECT='singleSelect'
const YES_NO='yesNo'

const ReviewQuestions=(props:ReviewQuestions$Props)=>{
    let questionElements = []

    props.questions.map(question=>{
        if (question.questionType == SINGLE_SELECT){
            questionElements.push(
                <SingleSelectAnswerQuestion 
                    key={question.elementId}
                    elementId={question.elementId}
                    answers={question.answers} 
                    questionText={question.questionText} 
                />
            )
        }else if (question.questionType == YES_NO){
            questionElements.push(
                <YesNoAnswerQuestion 
                    key={question.elementId}
                    elementId={question.elementId}
                    changeFieldValue={props.changeFieldValue} 
                    questionText={question.questionText}
                    yesSubQuestionText={question.yesSubQuestionText}
                    yesSubAnswers={question.yesSubAnswers}
                />
            )
        }
    })

    return questionElements
}

export default ReviewQuestions


// WEBPACK FOOTER //
// ./src/components/QualityReview/ReviewQuestions.js